export const ApiEndpoints = {
  auth: {
    userSearch: '/auth/user/search',
    password: '/auth/password',
    requestOtpCode: '/auth/otp/request-code',
    validateOtpCode: '/auth/otp/validate-code'
  },
  account: {
    register: '/account/register',
    updateMe: '/account/me/data/update',
    getUserMeData: '/account/me/data',
    changePassword: '/account/me/security/change-password',
    createPassword: '/account/me/security/create-password',
    recoveryCheckCode: '/account/recovery/check-code',
    recoveryResetPassword: '/account/recovery/reset-password',
    verify: '/account/verify'
  },
  security: {
    verifyCaptcha: '/security/verify-captcha'
  },
  services: {
    getAddressByCep: '/services/address/{cep}'
  },
  terms: {
    acceptStatus: '/terms/accept/status',
    accept: '/terms/accept'
  }
};
